import styled from 'styled-components';

const TOGGLE_WIDTH = 44;
const SLIDER_WIDTH = 24;
const TRANSFORM_DISTANCE = TOGGLE_WIDTH - SLIDER_WIDTH;

export const ToggleButton = styled.span`
  position: relative;
  display: inline-block;
  width: ${TOGGLE_WIDTH}px;
  height: 21px;
  border: 1px solid ${(props: any) => props.theme.carvana.gray.light};
  border-radius: 16px;
  opacity: ${(props: any) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props: any) => (props.disabled ? 'not-allowed' : 'default')};

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: ${(props: any) => (props.disabled ? 'not-allowed' : 'pointer')};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${(props: any) => props.theme.carvana.gray.medium};
  -webkit-transition: 0.4s;
  transition: 0.4s;
  border-radius: 34px;

  ::before {
    position: absolute;
    content: '';
    top: -2px;
    left: -1px;
    height: 23px;
    width: ${SLIDER_WIDTH}px;
    border: 1px solid ${(props: any) => props.theme.carvana.gray.light};
    background-color: ${(props: any) => props.theme.carvana.white.primary};
    box-shadow: 0 2px 3px rgba(25, 41, 61, 0.13);
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 16px;
  }

  &.is-on {
    background-color: ${(props: any) => props.theme.carvana.green.primary};
    ::before {
      -webkit-transform: translateX(${TRANSFORM_DISTANCE}px);
      -ms-transform: translateX(${TRANSFORM_DISTANCE}px);
      transform: translateX(${TRANSFORM_DISTANCE}px);
    }
  }
`;
